"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityContactDto = instanceOfFacilityContactDto;
exports.FacilityContactDtoFromJSON = FacilityContactDtoFromJSON;
exports.FacilityContactDtoFromJSONTyped = FacilityContactDtoFromJSONTyped;
exports.FacilityContactDtoToJSON = FacilityContactDtoToJSON;
exports.FacilityContactDtoToJSONTyped = FacilityContactDtoToJSONTyped;
const AddressDto_1 = require("./AddressDto");
/**
 * Check if a given object implements the FacilityContactDto interface.
 */
function instanceOfFacilityContactDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('address' in value) || value['address'] === undefined)
        return false;
    if (!('stripeCustomerId' in value) || value['stripeCustomerId'] === undefined)
        return false;
    if (!('isPrimary' in value) || value['isPrimary'] === undefined)
        return false;
    if (!('isBilling' in value) || value['isBilling'] === undefined)
        return false;
    return true;
}
function FacilityContactDtoFromJSON(json) {
    return FacilityContactDtoFromJSONTyped(json, false);
}
function FacilityContactDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'phoneNumber': json['phoneNumber'],
        'email': json['email'],
        'address': (0, AddressDto_1.AddressDtoFromJSON)(json['address']),
        'stripeCustomerId': json['stripeCustomerId'],
        'isPrimary': json['isPrimary'],
        'isBilling': json['isBilling'],
    };
}
function FacilityContactDtoToJSON(json) {
    return FacilityContactDtoToJSONTyped(json, false);
}
function FacilityContactDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'phoneNumber': value['phoneNumber'],
        'email': value['email'],
        'address': (0, AddressDto_1.AddressDtoToJSON)(value['address']),
        'stripeCustomerId': value['stripeCustomerId'],
        'isPrimary': value['isPrimary'],
        'isBilling': value['isBilling'],
    };
}
//# sourceMappingURL=FacilityContactDto.js.map